module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/fac-step4-de2d8c874dbedfa5183662f36451b222.svg";